import { Container, Draggable } from "react-smooth-dnd";
import SubForm from "./TemplateStructureDetail/SubForm";
import { useState } from "react";

const TemplateStructureDetail = ({
  isEditing,
  formTemplateStructure: formTemplate,
  setFormTemplateStructure: setFormTemplate,
  setSelectedField,
  selectedField,
  translate,
  roles,
}) => {
  const [updating, setUpdating] = useState(false);

  const onDrop = (dropResult) => {
    const { addedIndex, removedIndex, payload } = dropResult;
    if (removedIndex === null && addedIndex === null) return;

    setUpdating(true);

    const newFormTemplate = [...formTemplate];

    if (removedIndex !== null) {
      newFormTemplate.splice(removedIndex, 1);
    }

    if (addedIndex !== null) {
      newFormTemplate.splice(addedIndex, 0, payload);
    }

    newFormTemplate.forEach((form, index) => {
      form.index = index;
    });

    setFormTemplate(newFormTemplate);

    setUpdating(false);
  };

  return (
    <Container
      dragHandleSelector={isEditing ? ".sub-form-header" : ".no-drag-available"}
      groupName="form-template-structure"
      lockAxis="y"
      dragClass="cursor--grabbing"
      onDrop={(dropResult) => onDrop(dropResult)}
      shouldAcceptDrop={(sourceContainerOptions) =>
        sourceContainerOptions.groupName === "form-template-structure"
      }
      getChildPayload={(index) => ({
        ...formTemplate[index],
        source: "form",
        index,
      })}
    >
      {!updating &&
        formTemplate.map((template, i) => (
          <Draggable key={`template-${i}`}>
            <SubForm
              translate={translate}
              form={template}
              index={i}
              setFormTemplate={setFormTemplate}
              formTemplate={formTemplate}
              selectedField={selectedField}
              setSelectedField={setSelectedField}
              isEditing={isEditing}
              roles={roles}
            />
          </Draggable>
        ))}
    </Container>
  );
};

export default TemplateStructureDetail;
